import { render, staticRenderFns } from "./ThirdConfigList.vue?vue&type=template&id=0e4a5388"
import script from "./ThirdConfigList.vue?vue&type=script&lang=js"
export * from "./ThirdConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports